<div>{{ text() }}</div>
